<template>
	<section class="title-warp">
		<div class="title-box" v-for="(item, idx) in Titles" :key="idx">
			<h3 class="title one-line">{{item.Content}}</h3>
		</div>
	</section>
</template>

<script>
export default {
	name: 'English',
	props: ['Titles']
}
</script>

<style lang="scss" scoped>
.title-warp {
	padding: 12px 0;
}
.title-box {
	margin-bottom: 6px;
	.title {
		display: block;
		font-size: 16px;
		color: #333;
		font-weight: bold;
		margin-right: 8px;
	}
}
.title-box:last-child {
	.title {
		font-size: 12px;
		color: #333;
		font-weight: normal;
	}
}
</style>



// WEBPACK FOOTER //
// src/template/title/English.vue